import { Field } from 'formik';
import type { FieldProps } from 'formik';

import { Box } from '@frontend/components';

import ContactSelector from 'modules/common/smartComponents/contactSelector/ContactSelector';
import { UNASSIGNED_VALUE as CONTACT_UNASSIGNED_VALUE } from 'modules/common/smartComponents/contactSelector/data/constants';

import type { FormData } from '../types';
import { HorizontalFormControl } from './HorizontalFormControl';

export const ContactFilter = () => {
  return (
    <HorizontalFormControl label="Contact">
      <Box w="100%">
        <Field name="contactIn">
          {({ field, form }: FieldProps<FormData['contactIn'], FormData>) => {
            return (
              <ContactSelector
                allowMultiSelect={true}
                allowUnassignedOption={true}
                onChange={(selectedContacts) => {
                  if (!selectedContacts) {
                    form.setFieldValue(field.name, []);
                    form.setFieldValue('contactIsUnassigned', false);
                  } else if (
                    selectedContacts.filter(
                      (s) => s.id === CONTACT_UNASSIGNED_VALUE,
                    ).length > 0
                  ) {
                    form.setFieldValue(field.name, []);
                    form.setFieldValue('contactIsUnassigned', true);
                  } else {
                    form.setFieldValue(
                      field.name,
                      selectedContacts.map((contact) => contact.id),
                    );
                    form.setFieldValue('contactIsUnassigned', false);
                  }
                }}
                selectedValues={
                  form.values.contactIsUnassigned
                    ? [CONTACT_UNASSIGNED_VALUE]
                    : field.value
                }
              />
            );
          }}
        </Field>
      </Box>
    </HorizontalFormControl>
  );
};
